export default __webpack_public_path__ + "static/media/tozzini.88a681e6.png";